import React from 'react';
import BottomNav from './BottomNav';

/**
 * AppLayout wraps all authenticated pages with the persistent bottom nav bar.
 * The pb-16 padding prevents page content being hidden behind the fixed nav.
 */
const AppLayout = ({ children }) => {
  return (
    <>
      <div className="pb-16">
        {children}
      </div>
      <BottomNav />
    </>
  );
};

export default AppLayout;
